import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubmenuDisplayHandlerService } from '../submenu-display-handler.service';

@Component({
  selector: 'kve-editors',
  templateUrl: './editors.component.html',
  styleUrls: ['./editors.component.scss']
})
export class EditorsComponent implements OnInit {
  showSubmenu = false;
  constructor(private router: Router,private submenuDisplayHandlerService:SubmenuDisplayHandlerService) { }

  ngOnInit(): void {
  }

  gotoEditor(location:string):void{
    console.log(location);
    this.router.navigateByUrl("kve/"+location, { skipLocationChange: true });
    this.submenuDisplayHandlerService.setShowSubMenu(true);
  }

}
